import React from 'react';
import { Typography, Button, Popover, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import InfoIcon from '@mui/icons-material/Info';
import { ChipStatus } from 'state/modules/lessonPlanner';
type Props =
  | {
      color: string;
      status: ChipStatus;
      body: string;
    }
  | any;

export const PopoverChip: React.FC<Props> = ({ color, status, ...props }: Props) => {
  const theme = useTheme();
  const classes = useStyles(theme)();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <div {...props}>
      <Button
        size="small"
        className={classes.button}
        aria-describedby={id}
        variant="contained"
        style={{ backgroundColor: color }}
        onClick={handleClick}
      >
        <Typography
          style={{
            display: 'flex',
            textTransform: 'none',
            fontSize: '12px',
            marginTop: '2px',
            paddingLeft: '2px'
          }}
        >
          {status}{' '}
          <InfoIcon
            style={{ marginLeft: 5, height: '.8em', alignSelf: 'center' }}
            fontSize="small"
          />
        </Typography>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        className={classes.popover}
        PaperProps={{ style: { backgroundColor: '#000000' } }}
      >
        <Typography className={classes.body}>{props.body}</Typography>
      </Popover>
    </div>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    popover: {
      marginBottom: '12px',
      top: '10px'
    },
    button: {
      borderRadius: '12px !important',
      height: '22px !important',
      flexBasis: 127,
      margin: '0 20px 0 0 !important',
      width: 'max-content !important'
    },
    body: {
      color: '#fff',
      height: '96px',
      width: '249px',
      padding: '12px',
      marginBottom: '12px',
      textAlign: 'left'
    },
    chip: () => ({
      backgroundColor: theme.palette.primary.main
    })
  }));
